import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-navbar-container',
  templateUrl: './navbar-container.component.html',
  styleUrls: ['./navbar-container.component.scss']
})
export class NavbarContainerComponent {
  @Input() breadcrumb: string | undefined;
}
